import { AddProductFromOrder } from './AddProductFromOrder'

export default AddProductFromOrder
